import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function IntroducciN() {
  return <section data-section-id="260598" id="introducción" className="relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_recycling.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_recycling.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_recycling.png-wvc-sizes" alt="Proceso industrial de reciclaje de acero" className="absolute inset-0 w-full h-full object-cover z-0" loading="eager" />

      {}
      <div className="absolute inset-0 bg-primary/60 z-10"></div>

      {}
      <div className="container relative z-20 px-4 md:px-6 mx-auto flex flex-col items-start text-left pt-20 pb-16 md:pt-32 md:pb-24 animate-in fade-in slide-in-from-bottom-5 duration-700">
        
        {}
        <span className="inline-block py-1.5 px-3 rounded-md bg-accent/20 text-accent text-xs md:text-sm font-default font-bold tracking-wider mb-6 uppercase border border-accent/30">COMPROMISO DE ACERO RESPONSABLE</span>

        {}
        <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-default font-bold text-white leading-[1.1] mb-6 max-w-4xl">EMPRESA SOCIALMENTE<br />RESPONSABLE</h1>

        {}
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mb-10 font-default leading-relaxed">En el año 2021 nos consolidamos como Empresa Socialmente Responsable. Obtener este distintivo nos reta a continuar mejorando y gestionando la responsabilidad social en nuestra organización, enfocando nuestras acciones para impactar de manera positiva en nuestra comunidad, colaboradores y medio ambiente. Creemos firmemente que debemos buscar un equilibrio sostenible a través de un comportamiento ético con base en los valores de Kalisch Acero.</p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button size="lg" className="bg-accent hover:bg-accent/90 text-white font-default font-semibold rounded-md h-14 px-8 text-base w-full sm:w-auto shadow-md hover:shadow-lg transition-all" asChild>
            <Link to="/SustainabilityPage">
              <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
              Nuestra Misión ESR
            </Link>
          </Button>
          
          <Button size="lg" variant="outline" className="bg-white/10 border-white/20 text-white hover:bg-white/20 hover:text-white rounded-md h-14 px-8 text-base w-full sm:w-auto backdrop-blur-sm" asChild>
            <Link to="/NosotrosPage">
              <Phone className="mr-2 h-5 w-5" />
              Contáctanos
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}